import { Icons } from '@silverfort/sf-components';
import { LogicalItemsTypes } from '../../../../TowerMenu/logicalMenuItems/LogicalItemsTypes';
import { PricingModules, usePricingModulesState } from '../../../../context/contexts/PricingModuleContext';
import { getIsCloudMenuDisabled, isUserPermitted } from '../../../../TowerMenu/TowerMenuUtils';
import { ROLES, TOWER_MENU_ITEMS } from '@silverfort-nodelibs/common/utils/consts';
import { MenuItemContainer } from '../../../../TowerMenu/logicalMenuItems/MenuItemContainer';

const ACCESS_ANALYSIS_MAIN_TITLE = 'Access Intelligence';
const ICON = Icons.Key;

export const AccessIntelligenceMenu = ({
    handleMenuItemSelection,
    userData,
    getTowerMenuHref,
    ...props
}: LogicalItemsTypes) => {
    const { pricingModulesState } = usePricingModulesState();

    const hasCloudLicense = pricingModulesState?.[PricingModules.ACCESS_ANALYSIS]?.cloudEnabled ?? false;
    const hasCloudPermission = isUserPermitted(userData, 'accessAnalysisCloud', ROLES.VIEWER.value);
    const hasOnPremLicense = pricingModulesState?.[PricingModules.ACCESS_ANALYSIS].onPremEnabled ?? false;
    const hasOnPremPermission = isUserPermitted(userData, 'accessAnalysis', ROLES.VIEWER.value);

    const isEnabled = hasOnPremLicense || hasCloudLicense;

    return (
        <MenuItemContainer
            {...props}
            parentId={TOWER_MENU_ITEMS.ACCESS_ANALYSIS}
            mainTitle={ACCESS_ANALYSIS_MAIN_TITLE}
            icon={ICON}
            userData={userData}
            handleMenuItemSelection={handleMenuItemSelection}
            showOnlyFirstItem={!isEnabled}
            getTowerMenuHref={getTowerMenuHref}
            menuItems={[
                {
                    id: TOWER_MENU_ITEMS.ACCESS_ANALYSIS_AD,
                    title: 'Active Directory',
                    disabled: !hasOnPremPermission
                },
                {
                    id: TOWER_MENU_ITEMS.ACCESS_ANALYSIS_CLOUD,
                    title: 'Cloud',
                    disabled: getIsCloudMenuDisabled(hasCloudLicense, hasCloudPermission, hasOnPremPermission),
                    earlyAvailability: true
                }
            ]}
        />
    );
};
